import React from 'react'


import {
    PartnersContainer,
    PartnersTextWrapper,
    PartnersWrapper,
    PartnersRow,

    PartnersCard,
    PartnersH1,
    PartnersH2,
    PartnersIcon,
    PartnersP,
    PartnersIconContainer,
    PartnersCardBanner,
    PartnersCardSvg,
    PartnersCardImg
} from './PartnersElements'

import partnerPhoto from '../../man-user.svg';
import partnerPhoto2 from '../../man-user2.svg';


const PartnersSection = ({type,lightBg,id,imgStart,title1, title2, title3, title4, p1,p1_2,p2,p2_2,p3,p3_2, Icon1, Icon2,Icon3,Icon4}) => {
    return (
        <>
            <PartnersContainer id='partners'>
                <PartnersTextWrapper>
                    <PartnersH1>Partners</PartnersH1>
                </PartnersTextWrapper>
                <PartnersWrapper>
                    <PartnersRow>
                        <PartnersCard white={true}> 
                            <PartnersCardBanner >
                                <PartnersCardImg src={partnerPhoto} alt="React Logo" />
                            </PartnersCardBanner>
                                <PartnersH2>{title1}</PartnersH2>
                                <PartnersP>{p1}</PartnersP>
                        </PartnersCard>
                        <PartnersCard white={true}> 
                            <PartnersCardBanner >
                                <PartnersCardImg src={partnerPhoto2} alt="React Logo" />
                            </PartnersCardBanner>
                                <PartnersH2>{title2}</PartnersH2>
                                <PartnersP>{p2}</PartnersP>
                        </PartnersCard>
                        <PartnersCard white={true}> 
                            <PartnersCardBanner >
                                <PartnersCardImg src={Icon3} alt="React Logo" />
                            </PartnersCardBanner>
                                <PartnersH2>{title3}</PartnersH2>
                                <PartnersP>{p3}</PartnersP>
                        </PartnersCard>
                    </PartnersRow>
                </PartnersWrapper>
            </PartnersContainer>
        </>
    )
}

export default PartnersSection
